"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidTakerFeeTokenError = exports.InvalidTokenReceivedError = exports.WrongNumberOfTokensReceivedError = exports.InvalidERC20AssetDataError = exports.InsufficientProtocolFeeError = exports.InsufficientTakerTokenError = exports.IncompleteFillBuyQuoteError = exports.IncompleteFillSellQuoteError = exports.InvalidTransformDataError = exports.InvalidTransformDataErrorCode = exports.InvalidExecutionContextError = exports.OnlyCallableByDeployerError = exports.TransformerFailedError = exports.NegativeTransformERC20OutputError = exports.IncompleteTransformERC20Error = exports.InsufficientEthAttachedError = void 0;

var revert_error_1 = require("../../revert_error"); // tslint:disable:max-classes-per-file


var InsufficientEthAttachedError = /*#__PURE__*/function (_revert_error_1$Rever) {
  _inherits(InsufficientEthAttachedError, _revert_error_1$Rever);

  var _super = _createSuper(InsufficientEthAttachedError);

  function InsufficientEthAttachedError(ethAttached, ethNeeded) {
    _classCallCheck(this, InsufficientEthAttachedError);

    return _super.call(this, 'InsufficientEthAttachedError', 'InsufficientEthAttachedError(uint256 ethAttached, uint256 ethNeeded)', {
      ethAttached: ethAttached,
      ethNeeded: ethNeeded
    });
  }

  return InsufficientEthAttachedError;
}(revert_error_1.RevertError);

exports.InsufficientEthAttachedError = InsufficientEthAttachedError;

var IncompleteTransformERC20Error = /*#__PURE__*/function (_revert_error_1$Rever2) {
  _inherits(IncompleteTransformERC20Error, _revert_error_1$Rever2);

  var _super2 = _createSuper(IncompleteTransformERC20Error);

  function IncompleteTransformERC20Error(outputToken, outputTokenAmount, minOutputTokenAmount) {
    _classCallCheck(this, IncompleteTransformERC20Error);

    return _super2.call(this, 'IncompleteTransformERC20Error', 'IncompleteTransformERC20Error(address outputToken, uint256 outputTokenAmount, uint256 minOutputTokenAmount)', {
      outputToken: outputToken,
      outputTokenAmount: outputTokenAmount,
      minOutputTokenAmount: minOutputTokenAmount
    });
  }

  return IncompleteTransformERC20Error;
}(revert_error_1.RevertError);

exports.IncompleteTransformERC20Error = IncompleteTransformERC20Error;

var NegativeTransformERC20OutputError = /*#__PURE__*/function (_revert_error_1$Rever3) {
  _inherits(NegativeTransformERC20OutputError, _revert_error_1$Rever3);

  var _super3 = _createSuper(NegativeTransformERC20OutputError);

  function NegativeTransformERC20OutputError(outputToken, outputTokenLostAmount) {
    _classCallCheck(this, NegativeTransformERC20OutputError);

    return _super3.call(this, 'NegativeTransformERC20OutputError', 'NegativeTransformERC20OutputError(address outputToken, uint256 outputTokenLostAmount)', {
      outputToken: outputToken,
      outputTokenLostAmount: outputTokenLostAmount
    });
  }

  return NegativeTransformERC20OutputError;
}(revert_error_1.RevertError);

exports.NegativeTransformERC20OutputError = NegativeTransformERC20OutputError;

var TransformerFailedError = /*#__PURE__*/function (_revert_error_1$Rever4) {
  _inherits(TransformerFailedError, _revert_error_1$Rever4);

  var _super4 = _createSuper(TransformerFailedError);

  function TransformerFailedError(transformer, transformerData, resultData) {
    _classCallCheck(this, TransformerFailedError);

    return _super4.call(this, 'TransformerFailedError', 'TransformerFailedError(address transformer, bytes transformerData, bytes resultData)', {
      transformer: transformer,
      transformerData: transformerData,
      resultData: resultData
    });
  }

  return TransformerFailedError;
}(revert_error_1.RevertError);

exports.TransformerFailedError = TransformerFailedError;

var OnlyCallableByDeployerError = /*#__PURE__*/function (_revert_error_1$Rever5) {
  _inherits(OnlyCallableByDeployerError, _revert_error_1$Rever5);

  var _super5 = _createSuper(OnlyCallableByDeployerError);

  function OnlyCallableByDeployerError(caller, deployer) {
    _classCallCheck(this, OnlyCallableByDeployerError);

    return _super5.call(this, 'OnlyCallableByDeployerError', 'OnlyCallableByDeployerError(address caller, address deployer)', {
      caller: caller,
      deployer: deployer
    });
  }

  return OnlyCallableByDeployerError;
}(revert_error_1.RevertError);

exports.OnlyCallableByDeployerError = OnlyCallableByDeployerError;

var InvalidExecutionContextError = /*#__PURE__*/function (_revert_error_1$Rever6) {
  _inherits(InvalidExecutionContextError, _revert_error_1$Rever6);

  var _super6 = _createSuper(InvalidExecutionContextError);

  function InvalidExecutionContextError(actualContext, expectedContext) {
    _classCallCheck(this, InvalidExecutionContextError);

    return _super6.call(this, 'InvalidExecutionContextError', 'InvalidExecutionContextError(address actualContext, address expectedContext)', {
      actualContext: actualContext,
      expectedContext: expectedContext
    });
  }

  return InvalidExecutionContextError;
}(revert_error_1.RevertError);

exports.InvalidExecutionContextError = InvalidExecutionContextError;
var InvalidTransformDataErrorCode;

(function (InvalidTransformDataErrorCode) {
  InvalidTransformDataErrorCode[InvalidTransformDataErrorCode["InvalidTokens"] = 0] = "InvalidTokens";
  InvalidTransformDataErrorCode[InvalidTransformDataErrorCode["InvalidArrayLength"] = 1] = "InvalidArrayLength";
})(InvalidTransformDataErrorCode = exports.InvalidTransformDataErrorCode || (exports.InvalidTransformDataErrorCode = {}));

var InvalidTransformDataError = /*#__PURE__*/function (_revert_error_1$Rever7) {
  _inherits(InvalidTransformDataError, _revert_error_1$Rever7);

  var _super7 = _createSuper(InvalidTransformDataError);

  function InvalidTransformDataError(errorCode, transformData) {
    _classCallCheck(this, InvalidTransformDataError);

    return _super7.call(this, 'InvalidTransformDataError', 'InvalidTransformDataError(uint8 errorCode, bytes transformData)', {
      errorCode: errorCode,
      transformData: transformData
    });
  }

  return InvalidTransformDataError;
}(revert_error_1.RevertError);

exports.InvalidTransformDataError = InvalidTransformDataError;

var IncompleteFillSellQuoteError = /*#__PURE__*/function (_revert_error_1$Rever8) {
  _inherits(IncompleteFillSellQuoteError, _revert_error_1$Rever8);

  var _super8 = _createSuper(IncompleteFillSellQuoteError);

  function IncompleteFillSellQuoteError(sellToken, soldAmount, sellAmount) {
    _classCallCheck(this, IncompleteFillSellQuoteError);

    return _super8.call(this, 'IncompleteFillSellQuoteError', 'IncompleteFillSellQuoteError(address sellToken, uint256 soldAmount, uint256 sellAmount)', {
      sellToken: sellToken,
      soldAmount: soldAmount,
      sellAmount: sellAmount
    });
  }

  return IncompleteFillSellQuoteError;
}(revert_error_1.RevertError);

exports.IncompleteFillSellQuoteError = IncompleteFillSellQuoteError;

var IncompleteFillBuyQuoteError = /*#__PURE__*/function (_revert_error_1$Rever9) {
  _inherits(IncompleteFillBuyQuoteError, _revert_error_1$Rever9);

  var _super9 = _createSuper(IncompleteFillBuyQuoteError);

  function IncompleteFillBuyQuoteError(buyToken, boughtAmount, buyAmount) {
    _classCallCheck(this, IncompleteFillBuyQuoteError);

    return _super9.call(this, 'IncompleteFillBuyQuoteError', 'IncompleteFillBuyQuoteError(address buyToken, uint256 boughtAmount, uint256 buyAmount)', {
      buyToken: buyToken,
      boughtAmount: boughtAmount,
      buyAmount: buyAmount
    });
  }

  return IncompleteFillBuyQuoteError;
}(revert_error_1.RevertError);

exports.IncompleteFillBuyQuoteError = IncompleteFillBuyQuoteError;

var InsufficientTakerTokenError = /*#__PURE__*/function (_revert_error_1$Rever10) {
  _inherits(InsufficientTakerTokenError, _revert_error_1$Rever10);

  var _super10 = _createSuper(InsufficientTakerTokenError);

  function InsufficientTakerTokenError(tokenBalance, tokensNeeded) {
    _classCallCheck(this, InsufficientTakerTokenError);

    return _super10.call(this, 'InsufficientTakerTokenError', 'InsufficientTakerTokenError(uint256 tokenBalance, uint256 tokensNeeded)', {
      tokenBalance: tokenBalance,
      tokensNeeded: tokensNeeded
    });
  }

  return InsufficientTakerTokenError;
}(revert_error_1.RevertError);

exports.InsufficientTakerTokenError = InsufficientTakerTokenError;

var InsufficientProtocolFeeError = /*#__PURE__*/function (_revert_error_1$Rever11) {
  _inherits(InsufficientProtocolFeeError, _revert_error_1$Rever11);

  var _super11 = _createSuper(InsufficientProtocolFeeError);

  function InsufficientProtocolFeeError(ethBalance, ethNeeded) {
    _classCallCheck(this, InsufficientProtocolFeeError);

    return _super11.call(this, 'InsufficientProtocolFeeError', 'InsufficientProtocolFeeError(uint256 ethBalance, uint256 ethNeeded)', {
      ethBalance: ethBalance,
      ethNeeded: ethNeeded
    });
  }

  return InsufficientProtocolFeeError;
}(revert_error_1.RevertError);

exports.InsufficientProtocolFeeError = InsufficientProtocolFeeError;

var InvalidERC20AssetDataError = /*#__PURE__*/function (_revert_error_1$Rever12) {
  _inherits(InvalidERC20AssetDataError, _revert_error_1$Rever12);

  var _super12 = _createSuper(InvalidERC20AssetDataError);

  function InvalidERC20AssetDataError(assetData) {
    _classCallCheck(this, InvalidERC20AssetDataError);

    return _super12.call(this, 'InvalidERC20AssetDataError', 'InvalidERC20AssetDataError(bytes assetData)', {
      assetData: assetData
    });
  }

  return InvalidERC20AssetDataError;
}(revert_error_1.RevertError);

exports.InvalidERC20AssetDataError = InvalidERC20AssetDataError;

var WrongNumberOfTokensReceivedError = /*#__PURE__*/function (_revert_error_1$Rever13) {
  _inherits(WrongNumberOfTokensReceivedError, _revert_error_1$Rever13);

  var _super13 = _createSuper(WrongNumberOfTokensReceivedError);

  function WrongNumberOfTokensReceivedError(actual, expected) {
    _classCallCheck(this, WrongNumberOfTokensReceivedError);

    return _super13.call(this, 'WrongNumberOfTokensReceivedError', 'WrongNumberOfTokensReceivedError(uint256 actual, uint256 expected)', {
      actual: actual,
      expected: expected
    });
  }

  return WrongNumberOfTokensReceivedError;
}(revert_error_1.RevertError);

exports.WrongNumberOfTokensReceivedError = WrongNumberOfTokensReceivedError;

var InvalidTokenReceivedError = /*#__PURE__*/function (_revert_error_1$Rever14) {
  _inherits(InvalidTokenReceivedError, _revert_error_1$Rever14);

  var _super14 = _createSuper(InvalidTokenReceivedError);

  function InvalidTokenReceivedError(token) {
    _classCallCheck(this, InvalidTokenReceivedError);

    return _super14.call(this, 'InvalidTokenReceivedError', 'InvalidTokenReceivedError(address token)', {
      token: token
    });
  }

  return InvalidTokenReceivedError;
}(revert_error_1.RevertError);

exports.InvalidTokenReceivedError = InvalidTokenReceivedError;

var InvalidTakerFeeTokenError = /*#__PURE__*/function (_revert_error_1$Rever15) {
  _inherits(InvalidTakerFeeTokenError, _revert_error_1$Rever15);

  var _super15 = _createSuper(InvalidTakerFeeTokenError);

  function InvalidTakerFeeTokenError(token) {
    _classCallCheck(this, InvalidTakerFeeTokenError);

    return _super15.call(this, 'InvalidTakerFeeTokenError', 'InvalidTakerFeeTokenError(address token)', {
      token: token
    });
  }

  return InvalidTakerFeeTokenError;
}(revert_error_1.RevertError);

exports.InvalidTakerFeeTokenError = InvalidTakerFeeTokenError;
var types = [InsufficientEthAttachedError, IncompleteTransformERC20Error, NegativeTransformERC20OutputError, TransformerFailedError, IncompleteFillSellQuoteError, IncompleteFillBuyQuoteError, InsufficientTakerTokenError, InsufficientProtocolFeeError, InvalidERC20AssetDataError, WrongNumberOfTokensReceivedError, InvalidTokenReceivedError, InvalidTransformDataError, InvalidTakerFeeTokenError, OnlyCallableByDeployerError, InvalidExecutionContextError]; // Register the types we've defined.

for (var _i = 0, _types = types; _i < _types.length; _i++) {
  var type = _types[_i];
  revert_error_1.RevertError.registerType(type);
}